/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { fetchAndAnonymise, fetchByFhirBulkDownload } from './fhirDownloadNetwork';

export async function doDownloadMrns(
  mrns: string,
  datasetCache: any[] | undefined,
  setDatasetCache: (x: any[]) => void,
  signal: AbortSignal,
  setProgress: (x: number) => void,
  setMrns: (x: (old: string) => string) => void
) {
  const dataset_ = [...(datasetCache || [])];
  const mrnList = mrns
    .split('\n')
    .map((x) => x.trim())
    .filter((x) => x);
  const numMRNs = mrnList.length;
  let errors = 0;
  for (let index = 0; index < numMRNs; index++) {
    if (signal.aborted) {
      break;
    }
    const mrn = mrnList[index]!;
    if (!mrn) continue;
    try {
      const { age, gender, diagnosticReports } = await fetchAndAnonymise(mrn, false, '*', signal, 3 /* Retries */);
      console.log('diagnosticReports:', diagnosticReports);
      const data = {
        age,
        gender,
        diagnosticReports: diagnosticReports.entry?.map((x) => {
          // All we need is the date (no time) and the coding
          const date = (x.resource as any)?.effectiveDateTime?.split('T')[0];
          const coding = (x.resource as any)?.code?.coding;
          return { date, coding };
        }),
      };
      dataset_.push(data);
      setDatasetCache(dataset_);
      setProgress(((index + 1) / numMRNs) * 100);
      // Remove this MRN from the list so that we can easily retry, including the following newline if one
      setMrns((old) => old.replace(new RegExp(`^${mrn}(\\n)?`), ''));
    } catch (e) {
      errors++;
      console.error('Error downloading patient data for MRN:', mrn, e);
    }
  }
  return { data: dataset_, errors };
}

export async function doDownloadGroup(
  groupId: string,
  FhirPageWidgetType: string,
  signal: AbortSignal,
  setProgress: (x: number) => void
) {
  const data = await fetchByFhirBulkDownload(groupId, FhirPageWidgetType, signal, setProgress);
  return { data, errors: 0 };
}
